module.exports = __webpack_public_path__ + "img/7.ded80b65.jpg";